'use client'

import { ReactNode } from 'react'
import { useRouter } from 'next/navigation'

type NavigateToSectionProps = {
  children: ReactNode
  locale: string
  sectionId: string
  className?: string
}

export default function NavigateToSection({ children, locale, sectionId, className }: NavigateToSectionProps) {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    
    // Store the target section in sessionStorage to scroll immediately on page load
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('scrollToSection', sectionId)
    }
    
    // Navigate to v1 page with hash
    router.push(`/${locale}/v1#${sectionId}`)
  }

  return (
    <a href={`/${locale}/v1#${sectionId}`} className={className} onClick={handleClick}>
      {children}
    </a>
  )
}
